<template>
<div>

<b-row class="m-0 justify-content-center mx-5">
  <div style="margin-top: 100px; width: 800px; max-width: 100%" class="mx-5 text-dark mx-3"> 
<h1>Impressum</h1>
<br>
<h4 class="my-2">Angaben gemäß § 5 TMG</h4>
<br>
Dorado Services UG (haftungsbeschränkt) <br>
Alte Reichenbacher Str. 11 <br>
08606 Oelsnitz
<br>
<br>
Handelsregister: 33860 <br>
Registergericht: Chemnitz
<br>
<br>
<h4 class="my-2">Kontakt</h4>
Telefon: +4915114904081
<br>
<br>
E-Mail: <a href="mailto:info@eatdorado.de">info@eatdorado.de</a> 
<h4 class="my-2">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h4>
<p>Alexander Paulus</p>
Dorado Services UG (haftungsbeschränkt) <br>
Alte Reichenbacher Str. 11 <br>
08606 Oelsnitz <br>
<h4 class="my-2">Streitschlichtung</h4>
Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a>.
Unsere E-Mail-Adresse finden Sie oben im Impressum.

Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
<h4 class="my-2">Haftung für Inhalte</h4>
Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.

Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
<h4 class="my-2">Haftung für Links</h4>
Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.

Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
<h4 class="my-2">Urheberrecht</h4>
Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.

Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
</div>
</b-row>
<Footer class="my-5"></Footer>
  </div>
</template>

<script>
import coreData from '@/mixins/coreDataMixin'
import Footer from '@/components/Footer'

export default {
  name: 'Impressum',
  mixins: [coreData],
  components: {
    Footer
  },
  mounted(){
    window.scrollTo({top: 0});
  },
  computed: {
    darkMode(){
      return this.$store.getters.darkMode
    }
  },
}
</script>